import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jqk33qjaz: FaireProductEntity = {
  token: "p_8jqk33qjaz",
  type: "product",
  name: "Evil Eye Tassel Fringe Cosmetic Bag",
  brandToken: "b_4ahkhhvtpz",
  brandName: "Collections by Fame Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/afa27cd769a0fba51f1164df70ecc49af3444fc98f9e795bd92c102bb30c4a6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8608d21d3976376af73d5a2e7c7f86e37013605e454f7ee9d2d278269ef49975.jpeg",
    "https://cdn.faire.com/fastly/1102e2e9e58e1930fe94d1772babadb6297e9326bd9f3489e154dd55a0a4df81.jpeg",
    "https://cdn.faire.com/fastly/02eec9dd13af822dde5207000fb55a8472da16139b8f902b3431a856d69be188.jpeg",
    "https://cdn.faire.com/fastly/f9967840a0d2a9cc22307463493c5c62f5a7d6111550ca04ca67023658289568.jpeg",
    "https://cdn.faire.com/fastly/41404483978b34b2a73efd6ab8be19f0b8b78ceac5925061b482fb57bf330f28.jpeg",
    "https://cdn.faire.com/fastly/fadf5907346b8dba4ed066d73aa2e72de82f064c3e598789e8ed6bed6dafb003.jpeg",
  ],
  priceDollars: 18.71,
  description:
    "This bag showcases a unique evil eye tassel fringe cosmetic style. Embark on a journey of sartorial refinement as this bag effortlessly complements your fashion sense.\r\n\r\nThis bag approximately measures (Inches):\r\nL: 10\r\nH: 7\r\n\r\n10% JUTE",
  tags: [],
  msrpDollars: 55.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:53.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
